const navList1 = [
    //公众服务
    {
        title:"公众服务",
        list:[
            {
                title:"长武蓝",
                path:"/gzfw/cwl",
                icon:require("@images/gzfw/icon-cwl.png"),
                type:2,
                idx:"",
                isSmrz:true,
            },
            {
                title:"法在身边",
                path:'/gzfw/fzsb',
                icon:require("@images/gzfw/icon-fzsb.png"),
                type:2,
                idx:"",
                isSmrz:true,
                params:{}
            },
            {
                title:"办事指南",
                path:'/gzfw/bszn',
                icon:require("@images/gzfw/icon-bszn.png"),
                type:2,
                idx:"",
                isSmrz:false,
                params:{}
            },
            {
                title:"旅游景点",
                path:"/hmhq/lyjq",
                icon:require("@images/gzfw/icon-lyjd.png"),
                type:1,
                idx:"",
                isSmrz:false,
                params:{
                    code:"03",
                    title:"旅游景点"
                }
            },
            {
                title:"社区圈",
                path:"/gzfw/sqq",
                icon:require("@images/gzfw/icon-sqq.png"),
                type:1,
                idx:"",
                isSmrz:true,
                params:{
                    title:"社区圈"
                }
            },
            {
                title:"长武同城",
                path:"/hmhq/wall",
                icon:require("@images/gzfw/icon-cwtc.png"),
                type:1,
                idx:"",
                isSmrz:false,
                params:{
                    title:"长武同城"
                }
            },
            {
                title:"政策之窗",
                path:"/xxgk/tzgg",
                icon:require("@images/gzfw/icon-zczc.png"),
                type:1,
                idx:"",
                isSmrz:false,
                params:{
                    title:"政策之窗"
                }
            },
            {
                title:"新闻资讯",
                path:"/gzfw/cwxw-list",
                icon:require("@images/gzfw/icon-xwzx.png"),
                type:1,
                idx:"",
                isSmrz:false,
                params:{
                    title:"新闻资讯"
                }
            },
            {
                title:"我要学法",
                path:"http://legalinfo.moj.gov.cn/",
                icon:require("@images/gzfw/icon-wyxf.png"),
                type:3,
                idx:"08",
                isSmrz:false,
                params:{
                    title:"我要学法"
                }
            },
            {
                title:"救助申请",
                path:"http://php.saxmz.gov.cn/jz_ask/index.php?action=index",
                icon:require("@images/gzfw/icon-jzsq.png"),
                type:3,
                idx:"",
                isSmrz:false,
                params:{
                    code:20
                }
            },
            {
                title:"异地就医",
                path:"pages/common/launch-screen",
                icon:"http://117.35.107.26:9876/zhshj-cw-io//ydjz_1672885130069.png",
                type:7,
                idx:"",
                isSmrz:false,
                params:{
                    uaername:"gh_95fd1700c01e",
                }
            },
            {
                title:"车次查询",
                path:"pages/bus/index/index",
                icon:"http://117.35.107.26:9876/zhshj-cw-io//cccx_1672885174515.png",
                type:8,
                idx:"",
                isSmrz:false,
                params:{
                    uaername:"gh_a982e843b128",
                }
            },
            {
                title:"法院在线",
                icon:require("@images/gzfw/icon-fyzx.png"),
                path:"/gzfw/fyzx",
                type:1,
                idx:"",
                isSmrz:false,
                params:{}
            },
            {
                title:"小法机器人",
                path:"https://ilawpush5.aegis-info.com/home",
                icon:require("@images/icon2/icon-xfjqr.png"),
                type:3,
                idx:"",
                isSmrz:false,
                params:{
                    code:23
                }
            },
            {
                title:"无线广播",
                path:"http://www.snrtv.com/snrtv_gbzb/index.html#fm988",
                icon:require("@images/gzfw/icon-wxgb.png"),
                type:3,
                idx:"",
                isSmrz:false,
                params:{
                    code:24
                }
            },
            {
                title:"企业年检",
                path:"https://sn.gsxt.gov.cn/index.html",
                icon:require("@images/gzfw/icon-qynj.png"),
                type:3,
                idx:"13",
                isSmrz:false,
                params:{
                    code:13
                }
            },
        ]
    },
    
    //民情直达
    {
        title:"民情直达",
        list:[
            {
                title:"随手报",
                path:"/hmhq/ssp",
                icon:require("@images/gzfw/icon-ssb.png"),
                type:2,
                idx:"",
                isSmrz:true,
                params:{}
            },
            {
                title:"双报到为民行",
                path:"/gzfw/sbdwmx",
                icon:require("@images/gzfw/icon-sbdwmx.png"),
                type:2,
                idx:"",
                isSmrz:true,
                params:{}
            },
            {
                title:"专家人才",
                path:"/hmhq/zyzx",
                icon:require("@images/gzfw/icon-zjrc.png"),
                type:2,
                idx:"",
                isSmrz:true,
                params:{}
            },
            {
                title:"物业服务",
                path:"/hmhq/wyfw",
                icon:require("@images/gzfw/icon-wyfw.png"),
                type:2,
                idx:"",
                isSmrz:true,
                params:{}
            },
            {
                title:"问题墙·回音壁",
                path:"/hmhq/problem",
                icon:require("@images/gzfw/icon-wtqhyb.png"),
                type:2,
                idx:"",
                isSmrz:true,
                params:{}
            },
           
        ]
    },
    //典型评选
    {
        title:"典型评选",
        list:[
            {
                title:"我要投票",
                path:"/xxgk/wytp",
                icon:require("@images/gzfw/icon-wytp.png"),
                type:1,
                idx:"",
                isSmrz:true,
                params:{
                    code:"01",
                    title:"好人好事",
                }
            },
           
        ]
    },
    //典型评选
    {
        title:"志愿服务",
        list:[
            {
                title:"文明实践",
                path:"https://cwxxsd.deepoceanbd.com/h5",
                icon:require("@images/gzfw/icon-wmsj.png"),
                type:3,
                idx:"10",
                isSmrz:true,
                params:{
                    code:"01",
                    title:"好人好事",
                }
            },
        ]
    },
]

export default navList1